// extracted by mini-css-extract-plugin
export default {"anotherPlans":"VLoz8DX---styles_anotherPlans__6DPIK","anotherPlan":"VLoz8DX---styles_anotherPlan__eGHip","title":"VLoz8DX---styles_title__Erl1L"};